import { FC, useEffect, useState } from 'react'
import { getPlayerIdFromCookies, getShortPlayerId, getStatsObject } from '../controllers/stats'
import Distribution from './Distribution'
import formatTime from '../util/formatTime'
import Modal, { ModalComponentProps } from './Modal'
import StatRow from './StatRow'

type Props = ModalComponentProps

const ModalStats: FC<Props> = ({ active, ...otherModalProps }) => {
	const onClickPlayerId = () => {
		// Copy to clipboard
		navigator.clipboard.writeText(getShortPlayerId())
		alert('Player ID copied to clipboard')
	}

	const [stats, setStats] = useState(getStatsObject())

	useEffect(() => {
		// Ensure we've got the latest stats on every open
		if (active) {
			setStats(getStatsObject())
		}
	}, [active])

	const pidFromCookies = getPlayerIdFromCookies()

	return (
		<Modal popup title="Statistics" name="stats" active={active} {...otherModalProps}>
			<StatRow label="Played" value={stats?.p || 0} />
			<StatRow label="Current streak" value={stats?.sk || 0} />
			<StatRow label="Best streak" value={stats?.b || 0} />
			{stats?.bt ? <StatRow label="Best time" value={formatTime(stats?.bt || 0)} /> : null}

			<h2>Score Distribution</h2>
			<Distribution distribution={stats?.dst || []} min={1} max={5} />
			<p className="stats__pid" onClick={onClickPlayerId}>
				PLAYER ID: {getShortPlayerId()}
				{pidFromCookies && (
					<>
						<br />
						<span>{pidFromCookies}</span>
					</>
				)}
			</p>
		</Modal>
	)
}

export default ModalStats
